<template>
  <nav class="navbar sticky-top navbar-dark bg-dark title">
    <div class="container-fluid">
      <router-link class="navbar-brand" aria-current="page" to="/">
        TSUNG-HUNG LIN
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item" v-for="(item, key) in navbarLink" :key="key">
            <router-link
              class="nav-link active"
              aria-current="page"
              :to="item.path"
              @click="closeNav"
            >
              {{ item.title }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <!-- ======= Hero Section ======= -->
  <section id="hero">
    <div class="hero-container">
      <h1>TSUNG-HUNG LIN</h1>
      <h2>Duke's NCUT WEB PAGE</h2>
    </div>
  </section>
  <!-- #hero -->
</template>

<script>
export default {
  name: "navbar",
  data() {
    return {
      navbarLink: [
        {
          path: "/",
          title: "回首頁",
        },
        {
          path: "/curriculumvitae",
          title: "個人介紹(Profile)",
        },
        {
          path: "/research",
          title: "研究方向、國際認證(Research&Certification)",
        },
        {
          path: "/publication",
          title: "論文、著作、發明(Publication)",
        },
        {
          path: "/project",
          title: "計畫、產學 (Project)",
        },
        {
          path: "/studentawards",
          title: "學生專題競賽獲獎(Student Special Awards)",
        },
        {
          path: "/higherEduSproutProject",
          title: "高教深耕計畫成果(Higher Education Sprout Project)",
        },
      ],
    };
  },
  methods: {
    closeNav: () => {
      let dom = document.getElementById("navbarNav");
      dom.classList.remove("show");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: "NotoSansTC";
  src: url("../assets/font/NotoSansTC-Regular.otf") format("truetype");
}
.title {
  padding-top: 1vh;
  padding-bottom: 1vh;
}

/*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/
#header {
  height: 50px;
  transition: all 0.5s;
  z-index: 997;
  transition: all 0.5s;
  background: #2d6760;
}
#header.header-scrolled {
  background: #1d443f;
  height: 60px;
}
#header .logo h1 {
  font-size: 30px;
  margin: 0;
  padding: 0;
  line-height: 0;
  font-weight: 700;
  letter-spacing: 1px;
}
#header .logo h1 a,
#header .logo h1 a:hover {
  color: #fff;
  text-decoration: none;
  line-height: 0;
}
#header .logo img {
  padding: 0;
  margin: 0;
  max-height: 40px;
}

#main {
  margin-top: 80px;
}

/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
@media (min-width: 1024px) {
  #hero {
    background-attachment: fixed;
  }
}
@media (max-width: 768px) {
  #hero h1 {
    font-size: 28px;
    line-height: 36px;
  }
  #hero h2 {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 30px;
  }
}
#hero {
  width: 100%;
  height: 45vh;
  background: url("../assets/img/background.jpg") top center;
  background-size: cover;
  position: relative;
  margin-bottom: -80px;
}
#hero:before {
  content: "";
  background: rgba(183, 210, 207, 0.25);
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
}
#hero .hero-container {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  padding-top: 50px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}
#hero h1 {
  margin: 0 0 10px 0;
  font-size: 48px;
  font-weight: 300;
  line-height: 56px;
  color: #fff;
}
#hero h2 {
  color: #eee;
  margin-bottom: 50px;
  font-size: 20px;
  font-weight: 300;
}
#hero .btn-get-started {
  font-family: "NotoSansTC", sans-serif;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 8px 28px 10px 28px;
  border-radius: 50px;
  transition: 0.5s;
  border: 1px solid #fff;
  color: #fff;
}
</style>
